import { useDispatch } from "react-redux";
import { changeChromosomeSelection } from "../redux/reducers/chromosomeSlice";
import { changeSliderPosition, changeSliderRepeatSelection, changeSliderGeneSelection, changeSliderWidth, changeSliderMethylationSelection, changeRepeatStart, changeRepeatEnd } from "../redux/reducers/sliderSlice";
import { changePointerPosition, changePointerSelection } from "../redux/reducers/pointerSlice";
import formatActionPayload from "../redux/formatActionPayload";

//const dispatch = useDispatch();

export const updateChromosomeSelection = (genome, selectedChromosome) => {
    return dispatch => {
        dispatch(changeChromosomeSelection(formatActionPayload(genome, selectedChromosome)));

        // clears what's been selected by ptr since it no longer applies
        dispatch(changePointerPosition(formatActionPayload(genome, -10)));
        dispatch(changePointerSelection(formatActionPayload(genome, [])));
    };
}

export const moveSlider = (genome, position) => {
    return dispatch => {
        dispatch(changeSliderPosition(formatActionPayload(genome, position)));
        dispatch(changePointerPosition(formatActionPayload(genome, -10)));
        dispatch(changePointerSelection(formatActionPayload(genome, [])));
    };
}

export const resizeRightSideSlider = (genome, width) => {
    return dispatch => {
        dispatch(changeSliderWidth(formatActionPayload(genome, width)));
        dispatch(changePointerPosition(formatActionPayload(genome, -10)));
        dispatch(changePointerSelection(formatActionPayload(genome, [])));
    };
}

export const resizeLeftSideSlider = (genome, position, width) => {
    return dispatch => {
        dispatch(changeSliderPosition(formatActionPayload(genome, position)));
        dispatch(changeSliderWidth(formatActionPayload(genome, width)));
        dispatch(changePointerPosition(formatActionPayload(genome, -10)));
        dispatch(changePointerSelection(formatActionPayload(genome, [])));
    };
}

export const updateSliderSelection = () => {

}